export default "__VITE_ASSET__nQQUARHT__"